import React from "react";

function Header() {
  return (
    <div className="list-books-title">
      <h1>MyReads</h1>
    </div>
  );
}

export default Header;



// WEBPACK FOOTER //
// ./src/Header.js